module.exports = __webpack_public_path__ + "img/samsunglogo.753c4dc8.png";